import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"
import styles from "./TeamContainer.module.scss"

const TeamContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section id="mm-team" className={cx(styles.Team, "pageContainer")} aria-label="Team page">
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default TeamContainer
